import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as REPORT_ACTION from '../constants/types/reportTypes'
import { stateStructure } from './_stateStructure.js'
import { setCookie } from '../helpers/unit';

const initialState = Immutable.fromJS(stateStructure.report);

export default function report(state = initialState, action) {

	let _state = state.toJS();

	switch (action.type) {

		case REPORT_ACTION.GET_TEAM_HISTORY:
		// 获取个人日工资
		case REPORT_ACTION.GET_PERSONAL_DAILY_WAGE:
		// 获取团队首页数据
		case REPORT_ACTION.GET_TEAM_USER_LIST:
		// 获取推广链接
		case REPORT_ACTION.GET_AGENT_REG_URL:
		// 获取真人反水
		case REPORT_ACTION.GET_LIVE_TEAM_SALARY:
		// 获取下级日工资
		case REPORT_ACTION.GET_TEAM_SALARY:
		// 获取真人下级契约
		case REPORT_ACTION.GET_TEAM_COMPACT_LIVE:
		// 获取投注记录
		case REPORT_ACTION.GET_LOTTERY_BET_HIS:
		// 获取彩票报表概要信息【含盈亏】
		case REPORT_ACTION.GET_WINLOSS_SUMMERY:
		// 获取追号列表
		case REPORT_ACTION.GET_TRACE_HIS:
		// 获取个人账变记录
		case REPORT_ACTION.GET_PERSONAL_SELFBANK_RECORD:
		// 获取日工资下级契约
		case REPORT_ACTION.GET_TEAM_COMPACT_DAILY:
		// 获取第三方游戏报表
		case REPORT_ACTION.GET_THRID_PARTY_GAME_REPORT_BYID:
		case REPORT_ACTION.GET_THRID_PARTY_GAME_REPORT_BYNAME:
		// 获取体育下级契约
		case REPORT_ACTION.GET_TEAM_COMPACT_SPORT:
		// 获取体育反水
		case REPORT_ACTION.GET_SPORT_REBET:
		// 获取真人反水
		case REPORT_ACTION.GET_LIVE_REBET:
		// 获取第三方转账记录
		case REPORT_ACTION.GET_TRANSFER_RECORD:
		// 获取玩法介绍
		case REPORT_ACTION.GET_METHOD_Q_A:
		// 获取常见问题
		case REPORT_ACTION.GET_Q_A:
		//  获取真人电子体育报表  下级详情
		case REPORT_ACTION.GET_LIVE_RECORD:
		// 获取彩票账变数据
		case REPORT_ACTION.LOTTERY_ACCOUNT_CHANGED:
		// 获取彩票契约分红
		case REPORT_ACTION.LOTTERY_DIVIDENDS_PINK:
		// 注册开户用户名验证
		case REPORT_ACTION.CHECK_USERNAME_FOR_REGISTER: {
			_state.current_view = action.cleanData;
			return state.merge(_state);
		}
		// 获取彩种返点信息
		case REPORT_ACTION.GET_LOTTERY_REBET_INFO: {
			_state.current_view = _state.current_view || {};
			_state.current_view.lottery_info = action.cleanData;
			return state.merge(_state);
		}
		// 获取第三方游戏投注报表
		case REPORT_ACTION.GET_THRID_PARTY_BET_REPORT: {
			_state.current_view = _state.current_view || {};
			_state.current_view.betDetail = action.cleanData;
			return state.merge(_state);
		}
		// 获取投注详情
		case REPORT_ACTION.GET_BET_DETAIL:
		// 查看分红契约
		case REPORT_ACTION.VIEW_LOTTERY_PINK:
		// 获取真人下级契约详情
		case REPORT_ACTION.GET_TEAM_COMPACT_DETAIL: {
			_state.current_view = _state.current_view || {};
			_state.current_view.detail = action.cleanData;
			return state.merge(_state);
		}
		// 获取下级充值限额
		case REPORT_ACTION.GET_TRANSFER_LIMIT: {
			_state.current_view = _state.current_view || {};
			_state.current_view.transferLimit = action.transferLimit;
			return state.merge(_state);
		}
		// 获取下级列表
		case REPORT_ACTION.GET_TEAM_GROUP_LIST: {
			_state.current_view = _state.current_view || {};
			_state.current_view.teamGroupList = action.cleanData;
			return state.merge(_state);
		}
		// 获取追号详情
		case REPORT_ACTION.GET_TRACE_HIS_DETAIL: {
			_state.current_view = _state.current_view || {};
			_state.current_view.trace_detail = action.cleanData;
			return state.merge(_state);
		}
		// 获取下级返点
		case REPORT_ACTION.GET_FOLLOWER_REBET: {
			_state.current_view = _state.current_view || {};
			_state.current_view.user_point = action.cleanData;
			return state.merge(_state);
		}
		// 销毁报表当前视图数据
		case REPORT_ACTION.DISTROY_CURRENT_VIEW: {
			_state.current_view = null;
			return state.merge(_state);
		}
		// 销毁报表当前详情数据
		case REPORT_ACTION.DISTROY_CURRENT_DETAIL: {
			_state.current_view = _state.current_view || {};
			_state.current_view.detail = null;
			return state.merge(_state);
		}
		// 注销用户
		case USER_ACTION.LOGOUT: {
			return initialState;
		}

		default:
			return state;
	}
}